import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Radio } from "antd";
import FormItem from "antd/lib/form/FormItem";
import TextArea from "antd/lib/input/TextArea";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfoModal from "./infoModal";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { FormattedMessage } from "react-intl";

const OptionalData = ({updateOptionalData}) => {
  const location = useLocation();

  const main = useSelector(state => state.main);
  const [accountable, setAccountable] = useState(null);
  const [encrypts, setEncrypts] = useState(false);
  const [hideDoc, setHideDoc] = useState(false);
  const [modal, setModal] = useState({
    content: null,
    title: null,
    visible: false
  });
  
  const [note, setNote] = useState("");
    
  const myType = main.myType;

  useEffect(() => {
    updateOptionalData(
      0, encrypts, hideDoc, [
        {
          "name": "periodo",
          "value": null,
          "correctedValue": null
        },
        {
          "name": "documento.tipo",
          "value": null,
          "correctedValue": null
        }
      ], note, accountable
    );
  }, [accountable, encrypts, hideDoc, note]);
  
  useEffect(() => {
    if (!location.state) return undefined;

    setAccountable(location.state?.isAccountable);
    return undefined;  
  }, [location.state]);
  
  const openModal = (title, content) => {
    const modal = {
      content: content,
      title: title,
      visible: true
    };
    setModal(modal);   
  };
  
  const renderInfoIcon = (infoType) => {
    let title;
    let content;
    if (infoType === 0) {
      title = <FormattedMessage id="upload.optionalData.crypt.title" />;
      content = (
        <div>
          <FormattedMessage id="upload.optionalData.crypt.desc1" />
          <br />
          <br />
          <b><FormattedMessage id="upload.optionalData.crypt.desc2" /></b>
          <br />
          <FormattedMessage id="upload.optionalData.crypt.desc3" />
          <br />
          <br />
          <FormattedMessage id="upload.optionalData.crypt.desc4" />
        </div>
      );
    } else {
      title = <FormattedMessage id="upload.optionalData.onlyStudio.title" />;
      content =
      (
        <div>
          <FormattedMessage id="upload.optionalData.onlyStudio.desc1" />
          <br />
          <br />
          <FormattedMessage id="upload.optionalData.onlyStudio.desc2" />
        </div>
      );
    }
    return (
      <FontAwesomeIcon icon={["far", "info-circle"]} 
        style={{ color: "#152935", cursor: "pointer" }} 
        onClick={ () => openModal(title, content)} />
    );
  };

  return (
    <div style={{ margin: "40px 0" }}>
      <div id="titleForm"><FormattedMessage id="upload.mainData" /></div>
      <div id="subtitleForm"></div>
      <div style={{ display: "flex", flexDirection: "row", marginTop: "16px" }}>
        <div style={{ flex: "0 0 auto", minWidth: "400px" }}>
          <div style={{ marginBottom: "16px" }}>
            <Radio checked={encrypts} onClick={e => setEncrypts(!e.target.value)}>
              <FormattedMessage id="upload.optionalData.crypt.title" />
            </Radio>
            {renderInfoIcon(0)}
          </div>
          {myType === "STUDIO" && (
            <div>
              <Radio checked={hideDoc} onClick={e => setHideDoc(!e.target.value)}>
                <FormattedMessage id="upload.optionalData.onlyStudio.title" />
              </Radio>
              {renderInfoIcon(1)}
            </div>
          )}
          <div style={{ marginTop: "16px" }}>
            <Radio checked={accountable} onClick={e => setAccountable(!e.target.value)}>
              <FormattedMessage id="upload.optionalData.toAccount.title" />
            </Radio>
          </div>
        </div>
        <div style={{ flex: "1 0 auto" }} className="textareaRight">
          <FormItem
            label={<FormattedMessage id="upload.comments" />}
            style={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start"
            }}
          >
            <TextArea className="vaporTextarea" onChange={e => setNote(e.target.value)} >
              {note}
            </TextArea>
          </FormItem>
        </div>
      </div>
      <InfoModal
        content={modal.content}
        isVisible={modal.visible}
        onClose={e => setModal(prev => { return {...prev, visible: false};})}
        title={modal.title}
      />
    </div>
  );
};

OptionalData.propTypes = {
  updateOptionalData: PropTypes.func,
  myType: PropTypes.string
};

export default OptionalData;
  